export const HQ_ADDRESS = Object.freeze({
    full: "375 S Main St, Suite 100, Alpine, UT 84004",
    street: "375 S Main St, Suite 100",
    cityStateZip: "Alpine, UT 84004",
});